/* eslint-disable @typescript-eslint/no-explicit-any */
import { VideoCallSocketContext } from "@contexts/videocall";
import { useCallback, useContext } from "react";

type SocketEvents = 'create_user' | 'create_call' | 'answer_call' | 'leave_call' | 'leave_call' | 'cancel_call' | 'precall'
// type SocketListen = 'new_active' | 'recive_call' | 'leave' | 'users_in_call' | 'no_event'

// interface EventListen {
//     event: SocketListen,
//     data: any
// }

// interface User {
//     name: string;
//     id: string;
// }

// interface BasicCall {
//     name: string;
//     id: string;
//     token: string;
// }
export interface ICreateCallData
{
    id: string,
    room: string,
    name: string,
    nameEmit: string,
    token: string
}
export enum UserStatus {
    AVAILABLE,
    BUSY
}
export interface IUserVoiceCall{
    username: string,
    id: string,
    name: string,
    role: string,
    status: UserStatus
}
const useVideoCallSocket = () => {
    const { socketVideo } = useContext(VideoCallSocketContext)

    const emitSocketVideoEvent = useCallback((event: SocketEvents, data: any) => {
        if(socketVideo) {
            switch(event) {
                case "create_user":
                    socketVideo.emit("create_user", {username: data.username, name: data.name, role: data.role});
                    break;
                case "create_call":
                    socketVideo.emit("create_call", {
                        nameEmit: data.name,
                        name: data.nameUser,
                        username: data.username,
                        id: data.id,
                        token: data.token,
                        room: `${data.id}${socketVideo.id}`,
                    });
                    break;
                case "answer_call":
                    socketVideo.emit("answer_call", {
                        id: data.id,
                        idEmit: data.idEmit,
                        room: data.room,
                    });
                    break;
                case "leave_call":
                    console.log("Leaving emit::", data)
                    socketVideo.emit("leave_call", {
                        name: data.nameEmit,
                        id: data.id,
                        token: data.token,
                        room: data.room,
                        idEmit: data.idEmit,
                    });
                    break;
                case "cancel_call":
                    socketVideo.emit("cancel_call", {
                        name: data.name,
                        id: data.id,
                        token: data.token,
                        room: data.room,
                        idEmit: data.nameEmit,
                    });
                    break;
                case "precall":
                    socketVideo.emit("precall", {
                        room: `${data.id}${socketVideo.id}`,
                    })
                    break;
            }
        }
    }, [socketVideo]);

    return {emitSocketVideoEvent}
}

export default useVideoCallSocket;